import { render, staticRenderFns } from "./voip3CXLinkToTask.vue?vue&type=template&id=66ce2af2&scoped=true"
import script from "./voip3CXLinkToTask.vue?vue&type=script&lang=js"
export * from "./voip3CXLinkToTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ce2af2",
  null
  
)

export default component.exports